export default "__VITE_ASSET__GEtyhsXP__"